import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TreeItem, TreeItemButton } from "@air/component-tree";
import { Check } from "@air/next-icons";
import { Tooltip } from "@air/primitive-tooltip";
export const BoardSelectListItem = (param)=>{
    let { children, disabled, disabledMessage, id, isExpanded, isSelected, onSelect, onOpenChange, prefix, suffix, title } = param;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "BOARD_SELECT_LIST_ITEM",
        "data-id": id,
        "data-title": title,
        children: [
            /*#__PURE__*/ _jsx(TreeItem, {
                "data-id": id,
                onOpenChange: onOpenChange,
                open: isExpanded,
                prefix: prefix,
                size: "small",
                state: isSelected ? "selected" : "default",
                suffix: /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-1",
                    children: [
                        isSelected && /*#__PURE__*/ _jsx("div", {
                            className: "flex size-4 items-center justify-center rounded-full bg-blue-3",
                            children: /*#__PURE__*/ _jsx(Check, {
                                className: "size-3 text-blue-11"
                            })
                        }),
                        suffix
                    ]
                }),
                children: /*#__PURE__*/ _jsx(Tooltip, {
                    label: disabled && !!disabledMessage ? disabledMessage : undefined,
                    children: /*#__PURE__*/ _jsx(TreeItemButton, {
                        className: disabled ? "opacity-40" : "opacity-100",
                        disabled: disabled,
                        onClick: onSelect,
                        children: title
                    })
                })
            }),
            !!children && isExpanded && /*#__PURE__*/ _jsx("div", {
                className: "pl-6",
                children: children
            })
        ]
    });
};
